import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const Status = styled(SVG)`
  height: 56px;
  width: 56px;
  margin-bottom: 32px;
`;

export const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
`;

export const MessageStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin-top: 32px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
